// @flow
import styled from "styled-components";

export const DialogStyle = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 1300;
    top: 0;
    left: 0;
    display: flex;
`;

export const FullHeight = styled.div`
    min-height: 100vh;
    background-color: red;
`;

export const Centered = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
`;



// WEBPACK FOOTER //
// ./src/utils/styled.js